import jQuery from 'jquery';

import { ajax } from 'legacy/ajax';
import EXCEPTION_FILTERS from "./exception_filters";

export default {
  PageEvents: { },

  MAX_ERRORS_REPORTED_PER_PAGE: 2,
  errorsSentOnCurrentPage: 0,

  // override this flag for different handling (i.e. in non-production mode)
  suppressBrowserErrorHandling: true,

  logError(message) {
    this.logToConsole(message, 'error');
    this.sendError(message);
  },

  logWarning(message) {
    this.logToConsole(message, 'warning');
  },

  logInfo(message) {
    this.logToConsole(message, 'info');
  },

  log(message) {
    this.logToConsole(message, 'debug');
  },

  // override this method for different handling (i.e. in non-production mode)
  handleException(ex, context) {
    this.sendError(ex, context, false);
  },

  displayError(exceptionOrString, context) {
    if (!jQuery.isReady) {
      if (this.errorsSentOnCurrentPage <= this.MAX_ERRORS_REPORTED_PER_PAGE) {
        alert("Oops, a Javascript error has occurred\n" + this.exceptionToString(exceptionOrString, context));
      }
    } else {
      if (this.errorsSentOnCurrentPage === 0) {
        jQuery('#error_dialog').modal('show').find('.content').html(this.exceptionToHtml(exceptionOrString, context));
      } else {
        jQuery('#error_dialog').modal('show').find('.content').append("<br /><br />Total errors detected: " + (this.errorsSentOnCurrentPage + 1));
      }
    }
  },

  // defined in logging.js when logging is desired
  logToConsole(/* message, type */) {

  },

  exceptionToString(e, context) {
    return this.formatException(e, context, "\n", 200);
  },

  exceptionToHtml(e, context) {
    return this.formatException(e, context, "<br />", 500);
  },

  formatException(e, context, newline, backtraceLimit) {
    if (typeof e === "string") {
      return e;
    }

    return (context ? "Context: " + context + newline : '') +
      e.name + ": " + e.message + newline +
      (e.description && e.description !== e.message ? ('Description: ' + e.description + newline) : '') +
      (e.fileName ? (e.fileName + ", on line: " + e.lineNumber + (e.charNumber ? ":" + e.charNumber : '') + newline) : '') +
      (e.stack ? (newline + "Backtrace: " + newline +
        e.stack.replace("\n", newline).substring(0, backtraceLimit)) : "");
  },

  sendError(exceptionOrString, context, showStatus, ignoreFilterList) {
    var params;
    var ignoreFilters = ignoreFilterList || false;

    if (typeof exceptionOrString === "string") {
      params = { context: context,
        message: exceptionOrString };
    } else {
      params = { context: context,
        message: exceptionOrString.message,
        name: exceptionOrString.name,
        backtrace: exceptionOrString.stack };

      if (exceptionOrString.fileName) { params['filename'] = exceptionOrString.fileName; }
      if (exceptionOrString.lineNumber) { params['line'] = exceptionOrString.lineNumber; }
      if (exceptionOrString.charNumber) { params['character'] = exceptionOrString.charNumber; }
    }

    this.addPageEventsToParams(params);

    if (this.pageLoadedAsLocalFile()) {
      this.logWarning("Error not reported, since page is running as local file: " + params['message']);
      return;
    }

    if (!ignoreFilters && this.filter_exception(params)) {
      this.logWarning("Error filtered: " + params['message']);
      return;
    }

    this.errorsSentOnCurrentPage++;
    if (this.errorsSentOnCurrentPage > this.MAX_ERRORS_REPORTED_PER_PAGE) {
      if (this.errorsSentOnCurrentPage < 5) {
        this.logWarning("Max errors already reported on this page. Ignoring error: " + params['message']);
      }
      return;
    }

    jQuery('#error_dialog').find('.message').removeClass("color-error").html('Submitting error report...');

    ajax({
      url: '/logging/javascript_error.json?ajax=1',
      data: params,
      type: "POST",
      custom_error_handling: true,
      success: function(data, textStatus) {
        if (showStatus) {
          // in case the error dialog has been shown
          jQuery('#error_dialog').find('.message').removeClass("color-error").html('We\'ve been notified about this issue and will investigate it right away.');
        }
      },
      error_with_message: function(response, message, textStatus, status) {
        if (showStatus) {
          this.logToConsole(message, 'error');
          this.displayError(exceptionOrString, context);
          jQuery('#error_dialog').find('.message').addClass("color-error").html('Please email us the details below to: <a href="mailto:feedback@invoca.com?subject=JavaScript+Error+Report&body=+---+Please+paste+error+text+here+---">feedback@invoca.com');
        }
      }
    });
  },

  timeDifference(start, end) {
    if (!start || !end) {
      return '';
    }

    return end.getTime() - start.getTime();
  },

  filter_exception(params) {
    try {
      var filename   =   params.filename || '';
      var message    = (params.message || '').toString();
      var userAgent = navigator.userAgent.toLowerCase();

      if (userAgent.match(/blackberry|symbian/i)) {
        return true;
      }

      return this.filterExceptionByType("filename", filename) ||
        this.filterExceptionByType("message", message);
    } catch (e) {
      this.sendError(
        e,
        "filter_exception",
        false, /* don't show status */
        true /* ignore filters so we don't spin in a loop */
      );
    }

    return false;
  },

  filterExceptionByType(type, value) {
    if (!value) {
      return false;
    }

    for (var i = 0; i < EXCEPTION_FILTERS[ type ].length; ++i) {
      if (value.match(EXCEPTION_FILTERS[ type ][i])) {
        return true;
      }
    }

    return false;
  },

  pageLoadedAsLocalFile() {
    return window.location && window.location.protocol.search(/^file/) > -1;
  },

  addPageEventsToParams(params) {
    params['page_events'] = {};

    try {
      params['page_events']['timing'] = { dom_ready_ms: this.timeDifference(this.PageEvents.page_start, this.PageEvents.page_dom_ready),
        page_ready_ms: this.timeDifference(this.PageEvents.page_start, this.PageEvents.page_loaded),
        error_time_ms: this.timeDifference(this.PageEvents.page_start, new Date()) };
    } catch (ex) {
      params['page_events']['timing'] = ex.toString();
    }

    try {
      params['page_events']['mouse'] = { x: this.PageEvents.x || '-',
        y: this.PageEvents.y || '-' };

      // IE adds mouse coordinates to the global error event
      if (window.event && window.event['clientX']) {
        params['page_events']['mouse']['event_x'] = window.event['clientX'];
        params['page_events']['mouse']['event_y'] = window.event['clientY'];
      }
    } catch (ex) {
      params['page_events']['mouse'] = ex.toString();
    }

    try {
      params['page_events']['clicks'] = this.PageEvents.clicks || 'none';
    } catch (ex) {
      params['page_events']['clicks'] = ex.toString();
    }
  }
};
